export default {
  COMPLETED: 'Completado',
  TO_VALIDATE: 'Por validar',
  REQUIRED: 'Obligatorio',
  OPTIONAL: 'Opcional',
}
